import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

const LogoWrapper = styled(Grid)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        padding: ${theme.spacing(0, 1, 0, 0)};
        display: flex;
        text-decoration: none;
        font-weight: ${theme.typography.fontWeightBold};
`
);

const Logo = () => {
  const navigate = useNavigate();
  return (
    <LogoWrapper
      style={{ cursor: 'pointer' }}
      onClick={() => navigate('/dashboard')}
    >
      <img
        alt="logo"
        width={130}
        style={{ marginTop: 1 }}
        height={40}
        src={process.env.PUBLIC_URL + '/img/digiratina-logo.svg'}
      />
    </LogoWrapper>
  );
};

export default Logo;
